import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_UnitListComponent from "../components/_FM_unit/_FM_UnitListComponent";
import _FM_UnitFormComponent from "../components/_FM_unit/_FM_UnitFormComponent";
import _FM_UnitShowComponent from "../components/_FM_unit/_FM_UnitShowComponent";
import _FM_CategoryFormComponent from "../components/_FM_category/_FM_CategoryFormComponent";
import _FM_AccommodationImportFormComponent from "../components/_FM_accommodation/_FM_AccommodationImportFormComponent";
import _FM_BerthFormComponent from "../components/_FM_berth/_FM_BerthFormComponent";
import HelpComponent from "../components/HelpComponent";
import {Dialog} from "primereact/dialog";
import {Message} from "primereact/message";
import _FM_FolioShowComponent from "../components/_FM_folio/_FM_FolioShowComponent";
import _FM_BerthShowComponent from "../components/_FM_berth/_FM_BerthShowComponent";
import _FM_CategoryShowComponent from "../components/_FM_category/_FM_CategoryShowComponent";

const _FM_AccomodatonPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  useEffect(() => {
    document.title = t('units') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/unit')
  }, []);

  return (
    <div className="_FM_UnitPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/unit"}/>
      <Panel>
        <_FM_UnitListComponent />
      </Panel>
      <Sidebar position="right" visible={action === 'create' || action === 'update'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/unit');
               }}>
        <_FM_UnitFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/unit');
               }}>
        <_FM_UnitShowComponent />
      </Sidebar>
      <Dialog visible={window.App.urlVars().update === 'category'}
              header={t('residential_category')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_CategoryFormComponent />
      </Dialog>
      <Dialog visible={window.App.urlVars().update === 'berth'}
              header={t('berth')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_BerthFormComponent />
      </Dialog>
      <Dialog visible={window.App.urlVars().import === 'accommodation'}
              header={t('accommodation')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_AccommodationImportFormComponent />
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(_FM_AccomodatonPage);
